// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Stat_wrapper_3vvr7","key":"Stat_key_3mN8q","value":"Stat_value_2hzTg"};